var React = require('react');

function Pound (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M6 12h9M10.5 14.7c0 2.983-.617 6.3-3.6 6.3h10.8M17.7 6.6c0-1.986-1.613-3.6-3.6-3.6-1.989 0-3.6 1.614-3.6 3.6v8.1"}));
}

Pound.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Pound;

Pound.default = Pound;
